export const AGUASCALIENTES = 'Aguascalientes';
export const BAJA_CALIFORNIA_SUR = 'Baja California Sur';
export const BAJA_CALIFORNIA = 'Baja California';
export const CAMPECHE = 'Campeche';
export const CDMX_CIUDAD_DE_MEXICO = 'CDMX(Ciudad de México)';
export const CHIAPAS = 'Chiapas';
export const CHIHUAHUA = 'Chihuahua';
export const COAHUILA = 'Coahuila';
export const COLIMA = 'Colima';
export const DURANGO = 'Durango';
export const ESTADO_DE_MEXICO = 'Estado de México';
export const GUANAJUATO = 'Guanajuato';
export const GUERRERO = 'Guerrero';
export const HIDALGO = 'Hidalgo';
export const JALISCO = 'Jalisco';
export const MICHOACAN = 'Michoacán';
export const MORELOS = 'Morelos';
export const NAYARIT = 'Nayarit';
export const NUEVO_LEON = 'Nuevo León';
export const OAXACA = 'Oaxaca';
export const PUEBLA = 'Puebla';
export const QUERETARO = 'Querétaro';
export const QUINTANA_ROO = 'Quintana Roo';
export const SAN_LUIS_POTOSI = 'San Luis Potosí';
export const SINALOA = 'Sinaloa';
export const SONORA = 'Sonora';
export const TABASCO = 'Tabasco';
export const TAMAULIPAS = 'Tamaulipas';
export const TLAXCALA = 'Tlaxcala';
export const VERACRUZ = 'Veracrúz';
export const YUCATAN = 'Yucatán';
export const ZACATECAS = 'Zacatecas';



// WEBPACK FOOTER //
// ./src/utils/constants/ProvincesMx.js